import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const assetRegisters = api(async function assetRegisters({ search, take, skip, sort, descending }) {
    return query(
        gql`
            query GetAssetRegisters(
                $search: String
                $take: Int
                $skip: Int
                $sort: RegisterSort
                $descending: Boolean
            ) {
                assetRegisters(descending: $descending, sort: $sort, search: $search, take: $take, skip: $skip) {
                    totalCount
                    items {
                        _id
                        id
                        name
                        description
                        modified
                        created
                        cobieFiles
                        assetCount
                    }
                }
            }
        `,
        { search, take, skip, sort, descending },
        { returns: "assetRegisters" }
    )
})
